import React from 'react'
import {useStyles} from "./ExperienceIndication.css";
import {useIntl} from "react-intl";
import generalConfig from "../../associationStructure/generalConfig.json";

const ExperienceIndication = ({experience}) => {
    const classes = useStyles()

    // Internationalization for simple strings
    const intl = useIntl();

    if (!generalConfig.experience.includes(experience)) {
        return experience || ''
    }

    return <div className={classes[experience]}>
        {intl.formatMessage({
            id: `app.ids.expertise.${experience}`,
            defaultMessage: experience
        })}
    </div>
}
export default ExperienceIndication
